import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-sucursales',
  templateUrl: './dashboard-sucursales.component.html'
})
export class DashboardSucursalesComponent {}
